import React, { useState } from "react";

const Mouta = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  const products = [
    { 
      id: 81, 
      img: "https://i.postimg.cc/T2b0PFG4/l.png",
      caption: "(Chemistry) كيمياء"
    },
    { 
      id: 82, 
      img: "https://i.postimg.cc/xCnfbBh3/n.png",
      caption: "(Biology) علم الأحياء"
    },
    { 
      id: 83, 
      img: "https://i.postimg.cc/PrpjNtNk/py.png",
      caption: "(physics) فيزياء"
    },
    { 
      id: 84, 
      img: "https://i.postimg.cc/yddG5PZz/m.png",
      caption: "(Maths) رياضيات"
    },
  ];

  return (
    <section className="shop">
      <h1 className="section-title">متوسط</h1>
      <div className="product-list">
        {products.map((product) => {
          const whatsappMessage = `مرحبا هل يمكني انا استفسر عن التعليم الخصوصي للمتوسط (${product.caption}).`;
          const whatsappLink = `https://wa.me/70163001?text=${encodeURIComponent(whatsappMessage)}`;

          return (
            <div key={product.id} className="product-box">
              <div className="img-box">
                <img 
                  src={product.img} 
                  alt={product.caption} 
                  onClick={() => setSelectedImg(product.img)} 
                />
              </div>

              {/* الكابشن */}
              <p className="product-caption">{product.caption}</p>
               <br/>
              <a 
                href={whatsappLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="whatsapp-card"
              >
                <img 
                  src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
                  alt="WhatsApp" 
                  width="25" 
                  height="25" 
                />
                <span>التواصل عبر الواتس اب</span>
              </a>
            </div>
          );
        })}
      </div>

      {/* نافذة تكبير الصورة */}
      {selectedImg && (
        <div className="popup" onClick={() => setSelectedImg(null)}>
          <span className="close">&times;</span>
          <img src={selectedImg} alt="Zoomed" className="popup-img" />
        </div>
      )}
    </section>
  );
};

export default Mouta;
